// extracted by mini-css-extract-plugin
export default {"nav-link":"styles_nav-link__h5GWd","active":"styles_active__1U7Bu","nav-tabs":"styles_nav-tabs__czye3","nav":"styles_nav__OKjg-"};